import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loadbar',
  template: `
    <div *ngIf="visible" class="splash-screen">
      <div class="splash-container">
        <div class="logo"></div>
        <div class="load-bar">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>`
})
export class LoadbarComponent implements OnInit {

  @Input() visible = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/loadbar/loadbar.component.ts